import Document from '@tiptap/extension-document';

export const PreventNewLine = Document.extend({
  /**
   * `content: 'block'`:
   *
   * - Restricts the document root to only contain block-level nodes
   *   (like paragraphs, headings, lists, etc.).
   * - Prevents inline nodes (like text nodes, hard breaks) from being
   *   direct children of the document root.
   * - Note: Inline marks (like bold, italic) can still be applied to
   *   text within block nodes.
   */
  content: 'block',
  addKeyboardShortcuts() {
    return {
      Enter: () => true,
      'Shift-Enter': () => true,
    };
  },
});
